import React from "react";
import "./Contact.css";

import {MdOutlineMail} from "react-icons/md";
import {RiMessengerLine} from "react-icons/ri";
import {BsWhatsapp} from "react-icons/bs";

const Contact = ()=>{
    return (
        <section id="contact">

            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">

                <div className="contact__options">

                    <article className="contact__option">
                        <MdOutlineMail className="contact__option-icon" />   
                        <h4>Email</h4> 
                        <h5>dkjaiswal771999@gmail.com</h5> 
                        <a href="mailto:dkjaiswal771999@gmail.com" target={"_blank"}>Send a message</a>
                    </article> 

                    <article className="contact__option">
                        <RiMessengerLine className="contact__option-icon" />   
                        <h4>Messenger</h4> 
                        <h5>dk-jaiswal-77</h5> 
                        <a href="https://m.me/profile.php?id=100072096787997" target={"_blank"}>Send a message</a>
                    </article> 

                    <article className="contact__option">
                        <BsWhatsapp className="contact__option-icon" />   
                        <h4>Whatsapp</h4> 
                        <h5>dk-jaiswal-77</h5> 
                        <a href="https://api.whatsapp.com/send?phone+9779804239489" target={"_blank"}>Send a message</a>  
                    </article> 

                </div>

                <form action="">

                    <input type="text" name="name" placeholder="Your Full Name" required />

                    <input type="email" name="email" placeholder="Your Email" required />

                    <textarea name="message" rows="7" placeholder="Your Message" required ></textarea>

                    <button type="submit" className="btn btn-primary" >Send Message</button> 

                </form>

            </div>

        </section>
    );
}

export default Contact;